<template>
    <div
        id="be-attivita-recenti-gallery"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-8">
                                <h1 class="mb-0">{{$t('Attività recenti')}}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <b-table
                        class="attivita-recenti tabella-responsive table mt-5 mb-0"
                        striped
                        id="recent-activities"
                        :items="Array.from(Object.values(galleries))"
                        :fields="tableHead"
                        sort-icon-left
                        sticky-header="70vh"
                    >
                        <template #thead-top>
                            <b-tr>
                                <b-th class="border-top-0 border-right bg-transparent"></b-th>
                                <b-th
                                    variant=""
                                    colspan="4"
                                    class="text-blusbiadito"
                                >Visitatori</b-th>
                            </b-tr>
                        </template>

                        <template #head(galleryTitle)="data">
                            <span>{{data.label}}</span>
                        </template>

                        <template #head(visitorsWithFavorites)="
                                    data">
                            <font-awesome-icon
                                class="pt-1"
                                :icon="['fas', 'star']"
                                :title="data.label"
                            /><small class="ml-1">con preferiti</small>
                        </template>

                        <template #head(visitorsWithCartItems)="data">
                            <font-awesome-icon
                                class="pt-1"
                                :icon="['fas', 'shopping-cart']"
                                :title="data.label"
                            /><small class="ml-1">con articoli nel carrello</small>
                        </template>

                        <template #head(visitorsWithNoOrders)="data">
                            <font-awesome-icon
                                class="pt-1"
                                :icon="['fas', 'user-times']"
                                :title="data.label"
                            /><small class="ml-1">che non hanno effettuato ordini</small>
                        </template>

                        <template #head(visitorsWithOrders)="data">
                            <font-awesome-icon
                                class="pt-1"
                                :icon="['fas', 'money-bill-alt']"
                                :title="data.label"
                            /><small class="ml-1">che hanno effettuato ordini</small>
                        </template>

                        <template v-slot:cell(visitorsWithFavorites)="data">
                            <a
                                href=""
                                v-if="data.item.visitorsWithFavorites"
                                @click.prevent="goToVisitorsReport(data.item.galleryId, 'fav')"
                            >
                                {{data.item.visitorsWithFavorites}}
                            </a>
                            <span v-else> - </span>
                        </template>
                        <template v-slot:cell(visitorsWithCartItems)="data">
                            <a
                                href=""
                                v-if="data.item.visitorsWithCartItems"
                                @click.prevent="goToVisitorsReport(data.item.galleryId, 'cart')"
                            >
                                {{data.item.visitorsWithCartItems}}
                            </a>
                            <span v-else> - </span>
                        </template>
                        <template v-slot:cell(visitorsWithNoOrders)="data">
                            <a
                                href=""
                                class="preferiti"
                                v-if="data.item.visitorsWithNoOrders"
                                @click.prevent="goToVisitorsReport(data.item.galleryId, 'no-order')"
                            >
                                {{data.item.visitorsWithNoOrders}}
                            </a>
                            <span v-else> - </span>
                        </template>
                        <template v-slot:cell(visitorsWithOrders)="data">
                            <a
                                href=""
                                class="preferiti"
                                v-if="data.item.visitorsWithOrders"
                                @click.prevent="goToVisitorsReport(data.item.galleryId, 'order')"
                            >
                                {{data.item.visitorsWithOrders}}
                            </a>
                            <span v-else> - </span>
                        </template>
                    </b-table>
                </div>
            </main>
            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import { BTable } from "bootstrap-vue";

export default {
    name: "BackendRecentGalleryActivities",
    components: { BackendFooter, BackendHeader, BTable },
    data() {
        return {
            galleries: {},
            tableHead: [
                {
                    key: "galleryTitle",
                    label: "Titolo gallery",
                    thClass: "align-middle px-1 text-blusbiadito pl-3",
                    thStyle: { width: "30%" },
                    tdClass: "titolo align-middle px-1",
                    tdAttr: { "data-title": "Titolo gallery" },
                    sortable: true
                },
                {
                    key: "visitorsWithFavorites",
                    label: "Visitatori con preferiti",
                    thClass: "align-middle px-1 text-blusbiadito pl-3",
                    thStyle: { width: "15%" },
                    tdClass: "align-middle px-1",
                    tdAttr: {
                        "data-title": "Visitatori con preferiti"
                    },
                    sortable: true
                },
                {
                    key: "visitorsWithCartItems",
                    label: "Visitatori con articoli nel carrello",
                    thClass: "align-middle px-1 text-blusbiadito pl-3",
                    thStyle: { width: "15%" },
                    tdClass: "align-middle px-1",
                    tdAttr: {
                        "data-title": "Visitatori con articoli nel carrello"
                    },
                    sortable: true
                },
                {
                    key: "visitorsWithNoOrders",
                    label: "Visitatori che non hanno effettuato ordini",
                    thClass: "align-middle px-1 text-blusbiadito pl-3",
                    thStyle: { width: "15%" },
                    tdClass: "align-middle px-1",
                    tdAttr: {
                        "data-title":
                            "Visitatori che non hanno effettuato ordini"
                    },
                    sortable: true
                },
                {
                    key: "visitorsWithOrders",
                    label: "Visitatori che hanno effettuato ordini",
                    thClass: "align-middle px-1 text-blusbiadito pl-3",
                    thStyle: { width: "15%" },
                    tdClass: "align-middle px-1",
                    tdAttr: {
                        "data-title": "Visitatori che hanno effettuato ordini"
                    },
                    sortable: true
                }
            ]
        };
    },
    mounted() {
        this.$api
            .backendGetViewersReport()
            .then((result) => {
                console.debug("BACKEND_GET_VIEWERS_REPORT", result);
                let viewers = result.viewers;
                let galleries = {};
                for (let viewer in viewers) {
                    let galleryId = viewers[viewer].galleryId;
                    let galleryTitle = viewers[viewer].galleryTitle;
                    if (
                        !Object.prototype.hasOwnProperty.call(
                            galleries,
                            galleryId
                        )
                    ) {
                        galleries[galleryId] = {
                            galleryId: galleryId,
                            galleryTitle: galleryTitle,
                            visitorsWithFavorites: 0,
                            visitorsWithCartItems: 0,
                            visitorsWithNoOrders: 0,
                            visitorsWithOrders: 0
                        };
                    }
                    if (viewers[viewer].numFavorites !== 0) {
                        galleries[galleryId].visitorsWithFavorites++;
                    }
                    if (viewers[viewer].numInCart !== 0) {
                        galleries[galleryId].visitorsWithCartItems++;
                    }
                    if (viewers[viewer].numOrders === 0) {
                        galleries[galleryId].visitorsWithNoOrders++;
                    }
                    if (viewers[viewer].numOrders !== 0) {
                        galleries[galleryId].visitorsWithOrders++;
                    }
                }
                this.galleries = galleries;
            })
            .catch((error) => {
                console.error("BACKEND_GET_VIEWERS_REPORT", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            });
    },
    methods: {
        goToVisitorsReport(galleryId, filter) {
            this.$router.push({
                name: "backend-reports-visitors",
                query: { eventId: galleryId, filter: filter }
            });
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 767px) {
    th > small {
        display: none;
    }
    th > svg {
        padding-left: 5px;
    }
}

.table-b-table-default {
    background-color: #fafafa;
}
</style>
